import React from "react"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import styled from "styled-components"
import Flex from "@irati/ui/src/Flex"

const WellnessScissorsContainer = styled(Flex)`
  background-color: ${({theme}) => theme.colors.primary1_50};
  border-radius: ${({theme}) => theme.border.radius.large};
` as typeof Flex

export const WellnessScissorsIcon = ({size = "regular"}: {size?: "regular" | "large"}) => (
  <WellnessScissorsContainer
    alignItems="center"
    justifyContent="center"
    height={size === "regular" ? "62px" : "105px"}
    width={size === "regular" ? "62px" : "105px"}>
    <Icon icon={IconTypes.scissors} width={size === "regular" ? undefined : "74px"} height={size === "regular" ? undefined : "74px"} />
  </WellnessScissorsContainer>
)
